import React from 'react';
import './WelcomeScreen.css';

// Écran d'accueil plein écran (design original du Fief) :
// logo, statut d'ouverture en direct, téléphone, et le CTA qui déroule le site.
function WelcomeScreen({ openingStatus, onDiscover }) {
  const handleClick = (e) => {
    const screen = e.currentTarget.closest('.welcome-screen');
    if (screen) screen.classList.add('fade-out');
    setTimeout(onDiscover, 800);
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <div className="welcome-logo">
          <img src="/logo.svg" alt="Le Fief" />
        </div>

        <div className="welcome-tagline">
          American Food & Bar - Lacaze, Tarn
        </div>

        {!openingStatus.loading && openingStatus.message && (
          <div className={`welcome-status ${openingStatus.isOpen ? 'open' : 'closed'}`}>
            <span className="status-dot"></span>
            {openingStatus.message}
          </div>
        )}

        <div className="welcome-description">
          Cuisine US authentique au cœur de Lacaze. Produits locaux de qualité,
          ambiance conviviale. Votre destination gourmande par excellence.
        </div>

        <div className="welcome-phone">
          ☎ 07 49 11 01 86
        </div>

        <button className="welcome-discover-btn" onClick={handleClick}>
          Réserver ou Commander en ligne
        </button>
      </div>
    </div>
  );
}

export default WelcomeScreen;
